import React from 'react';

const LeadFinderHero = ({
  subredditUrl,
  setSubredditUrl,
  criteria,
  setCriteria,
  numberOfPosts,
  setNumberOfPosts,
  handleSearch,
  searchLoading,
  handleFocus
}) => {
  const postNumberOptions = Array.from({ length: 15 }, (_, i) => i + 1);

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[var(--color-primary-accent)] via-[#1A535C] to-[var(--color-secondary-accent)] text-white p-4 md:p-8 mb-10 shadow-2xl shadow-primary/20 min-h-[34vh] flex flex-col justify-center">
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-4">Uncover Hidden Leads</h1>
        <p className="text-xl md:text-2xl max-w-5xl mx-auto text-white/90 leading-relaxed mt-6 mb-8">
          Discover customers and collaborators in Reddit communities. WizeHelper’s AI pinpoints the right people and lets you craft personalized comments or direct messages.
        </p>

        <div id="lead-finder-form-container" className="bg-white/10 backdrop-blur-sm border border-white/20 pt-6 pb-1 px-8 rounded-xl max-w-5xl mx-auto">
          <form onSubmit={handleSearch} className="grid grid-cols-1 md:grid-cols-4 gap-6 items-center">
            <div className="relative">
              <label htmlFor="subreddit-url" className="sr-only">Subreddit URL</label>
              <input
                id="subreddit-url"
                className="w-full bg-transparent border-none rounded-md pl-12 pr-4 py-4 text-white placeholder:text-white/50 focus:ring-2 focus:ring-[var(--color-primary-accent)] transition"
                placeholder="Enter Subreddit or URL"
                type="text"
                value={subredditUrl}
                onFocus={handleFocus}
                onChange={(e) => setSubredditUrl(e.target.value)}
                required
                data-testid="leadFinder-subredditInput"
              />
            </div>
            <div className="relative">
              <label htmlFor="search-criteria" className="sr-only">Search Criteria</label>
              <input
                id="search-criteria"
                className="w-full bg-transparent border-none rounded-md pl-12 pr-4 py-4 text-white placeholder:text-white/50 focus:ring-2 focus:ring-[var(--color-primary-accent)] transition"
                placeholder="Enter search keywords"
                type="text"
                value={criteria}
                onFocus={handleFocus}
                onChange={(e) => setCriteria(e.target.value)}
                required
                data-testid="leadFinder-searchCriteriaInput"
              />
            </div>
            <div className="relative">
              <label htmlFor="number-of-posts" className="sr-only">Number of Posts</label>
              <select
                id="number-of-posts"
                value={numberOfPosts}
                onChange={(e) => setNumberOfPosts(parseInt(e.target.value))}
                className="w-full bg-transparent border border-[var(--color-border-subtle)] rounded-md pl-4 pr-10 py-3 text-white focus:ring-2 focus:ring-[var(--color-primary-accent)] transition appearance-none text-center hover:bg-white/10"
                aria-label="Number of posts to fetch"
                data-testid="leadFinder-numberOfPostsDropdown"
              >
                {postNumberOptions.map((num) => (
                  <option key={num} value={num} className="bg-[#1A535C] text-white">
                    {num} Posts
                  </option>
                ))}
              </select>
              <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-white/50 text-xl pointer-events-none">arrow_drop_down</span>
            </div>
            <button
              type="submit"
              id="find-leads-button"
              disabled={searchLoading}
              className="w-full bg-[var(--color-primary-accent)] text-white font-semibold py-3 px-6 rounded-lg hover:bg-[var(--color-secondary-accent)] transition-transform shadow-lg"
              data-testid="leadFinder-findLeadsButton"
            >
              {searchLoading ? (
                <div className="spinner"></div>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <span className="material-symbols-outlined">auto_awesome</span>
                  Find
                </span>
              )}
            </button>
          </form>
        </div>
      </div>

      <div className="mt-4 text-center relative z-10">
        <p className="text-white/70 text-xs mb-2 leading-relaxed">
          This service analyzes publicly available Reddit content. Usage is subject to
          <a href="https://www.redditinc.com/policies/data-api-terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-white mx-1">Reddit's API Terms</a>
          and our
          <a href="/privacy-policy" className="underline hover:text-white mx-1">Privacy Policy</a>.
          <br />
        </p>
      </div>
    </div>
  );
};

export default LeadFinderHero;
